import React, { forwardRef } from 'react';

import './count-tooltip.scss';
import Tooltip from '../v2/ui-elements/Tooltip';

// Keep the original styling

const MaterialUlTooltip = forwardRef(({ label, children, isIcon = false }, ref) => {
  // Simplify the conditional rendering
  // const hasLabel = label && label.length > 0;

  // If no valid label, return children without wrapper
  // if (!hasLabel) {
  //   return <span ref={ref}>{children}</span>;
  // }
  if (!label) return children;
  return (
    <Tooltip
      isIcon={isIcon}
      title={<div className="CountTooltip__Content">{label}</div>}
      arrow
      // PopperProps={{
      //   // Ensure consistent positioning
      //   modifiers: [
      //     {
      //       name: 'preventOverflow',
      //       enabled: true,
      //       options: {
      //         boundariesElement: 'viewport',
      //       },
      //     },
      //     {
      //       name: 'zIndex',
      //       enabled: true,
      //       phase: 'write',
      //       fn: ({ state }) => {
      //         state.styles.popper.zIndex = 10;
      //       },
      //     },
      //     {
      //       name: 'offset',
      //       enabled: true,
      //       options: {
      //         offset: [0, 8], // Slight offset from element
      //       },
      //     },
      //   ],
      // }}
      // Add these props for better reliability
      // disableInteractive={false}
      // enterDelay={100}
      // leaveDelay={100}
    >
      <span
        ref={ref}
        style={{
          display: 'inline-block',
          // cursor: 'pointer', // Ensure the element is interactive
        }}>
        {children}
      </span>
    </Tooltip>
  );
});

// Add display name for better debugging
// MaterialUlTooltip.displayName = 'MaterialUlTooltip';

export default MaterialUlTooltip;
